import axios from 'axios';
import { Promise } from 'es6-promise';
import environment from '../../../environment';

const defaultConfig = {
  baseURL: environment.baseUrl,
  timeout: 10000,
  headers: {
    common: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content
    }
  }
};

/** Creating the instance of Axios */
const apiClient = axios.create(defaultConfig);

/** Auth interceptors */
const authInterceptor = config => {
  return config;
};

/** Logger intercepters */
const loggerInterceptor = config => {
  return config;
};

/** Adding the request interceptors */
apiClient.interceptors.request.use(authInterceptor);
apiClient.interceptors.request.use(loggerInterceptor);

/** Adding the response interceptors */
apiClient.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

export { apiClient };
